import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgAlice = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="none"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#alice_svg__a)">
        <rect width={32} height={32} fill="#fff" rx={16} />
        <path fill="url(#alice_svg__b)" d="M0 0h32v32H0z" />
      </g>
      <defs>
        <clipPath id="alice_svg__a">
          <rect width={32} height={32} fill="#fff" rx={16} />
        </clipPath>
        <pattern
          id="alice_svg__b"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#alice_svg__c" transform="scale(.00444)" />
        </pattern>
        <image
          xlinkHref="data:image/png;base64,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"
          id="alice_svg__c"
          width={225}
          height={225}
          preserveAspectRatio="none"
        />
      </defs>
    </svg>
  );
};
export default SvgAlice;
